import { render, staticRenderFns } from "./OrdersSearch.vue?vue&type=template&id=5924bbd2&scoped=true"
import script from "./OrdersSearch.vue?vue&type=script&lang=js"
export * from "./OrdersSearch.vue?vue&type=script&lang=js"
import style0 from "./OrdersSearch.vue?vue&type=style&index=0&id=5924bbd2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5924bbd2",
  null
  
)

export default component.exports